/* TIK — race world behaviour.
   Two jobs only: let the times land once, and keep the film cheap.
   Everything on the page is readable and usable with this file absent. */
(function () {
  var root = document.documentElement;

  /* The `js` class gates every opacity:0 start state in tik-race.css.
     Without script the content simply renders — it never hides. */
  root.classList.add('js');

  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- one authored moment: the times land, once ---- */
  var landers = document.querySelectorAll('.r-land');
  if (calm.matches || !('IntersectionObserver' in window)) {
    for (var i = 0; i < landers.length; i++) landers[i].classList.add('in');
  } else {
    var seen = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    landers.forEach(function (el) { seen.observe(el); });
  }

  /* Safety net: anything still hidden 3s in gets shown regardless.
     The previous build could strand content at opacity 0 forever. */
  window.setTimeout(function () {
    document.querySelectorAll('.r-land:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  }, 3000);

  /* ---- the films ----
     querySelector only ever managed the first video, so a second one on the
     page was left to its own devices. */
  var films = [].slice.call(document.querySelectorAll('[data-film]'));
  if (!films.length) return;

  /* A film may ship two renditions instead of a <source> child. Pick one from
     how wide the frame really measures here.

     The threshold is deliberately above what a naive pixel count suggests.
     The homepage frame measures 466px, so at DPR 2 it "needs" 932 and a 900
     threshold handed it the 1080p master at 7.2 Mbps — for a background loop
     the size of a postcard, competing with two more films on the same page.
     Sharpness nobody can see is not worth a stutter everybody can. Only a
     frame genuinely wider than this gets the heavy rendition. */
  films.forEach(function (f) {
    if (f.currentSrc || f.src || !f.dataset.hd) return;
    var w = f.getBoundingClientRect().width || window.innerWidth;
    var need = w * Math.min(window.devicePixelRatio || 1, 2);
    f.src = need > 1100 ? f.dataset.hd : f.dataset.sd;
  });

  /* Reduced motion: never autoplay. Show the poster and give a real control. */
  if (calm.matches) {
    films.forEach(function (f) {
      f.removeAttribute('autoplay');
      f.setAttribute('controls', '');
    });
    return;
  }

  films.forEach(function (f) {
    f.setAttribute('disablepictureinpicture', '');
  });

  if (!('IntersectionObserver' in window)) {
    films.forEach(function (f) {
      var p = f.play();
      if (p && p.catch) p.catch(function () {});
    });
    return;
  }

  /* Buffer ahead rather than starting cold: with preload="metadata" the first
     play() has to fetch from scratch and stalls a few frames in, which on a
     loop this short reads as stutter.

     But raising .preload on EVERY film at load time makes three HD videos
     fetch at once over one connection, and then they all stutter instead of
     one. So the promotion to preload="auto" happens per film, inside the
     observer, 300px before it is needed: still ahead of time, but one at a
     time and only for films the visitor is actually reaching.

     Never call .load() here. It ABORTS the fetch autoplay already started and
     resets the element to its poster — the very flash-back-to-still it was
     meant to prevent. */
  var watch = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var f = e.target;
      if (e.isIntersecting) {
        if (f.preload !== 'auto') f.preload = 'auto';
        var p = f.play();
        if (p && p.catch) p.catch(function () { /* autoplay refused; poster stands in */ });
      } else if (!f.paused) {
        f.pause();
      }
    });
  }, { threshold: 0.01, rootMargin: '300px 0px 300px 0px' });

  films.forEach(function (f) { watch.observe(f); });
})();
